import { createFileRoute } from '@tanstack/react-router';

import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';
import { IncidentesPage } from '@/features/compliance/components/incidentes-page';

export const Route = createFileRoute('/_app/compliance/incidentes')({
  component: ComplianceIncidentesRoute,
});

function ComplianceIncidentesRoute() {
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <IncidentesPage />
    </div>
  );
}
